import { Component, AfterViewInit, ElementRef, Renderer, ViewChild } from '@angular/core';

import { BreadcrumbService } from 'ng5-breadcrumb';
import { Subscription } from 'rxjs';
import { bObservableUsuario } from './util/observable-util';
import { PadraoService } from './service/padrao.service';
import { environment } from 'environments/environment';
import { JwtHelper } from "angular2-jwt";
import { AppTopBar } from './app.topbar.component';
import { DomSanitizer, SafeValue } from '@angular/platform-browser';
import { Message } from 'primeng/primeng';
import { EventEmitterService } from './util/emitter-service/emitter-service';
import { EVENT_MSGS_UPDATE } from './util/emitter-service/nome-evento';
import { AutenticacaoService } from './service/autenticacao.service';


enum MenuOrientation {
    STATIC,
    OVERLAY,
    HORIZONTAL
}

declare var jQuery: any;

@Component({
    selector: 'app-root',
    templateUrl: 'app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent implements AfterViewInit {

    layoutCompact: boolean = false
    layoutMode: MenuOrientation = MenuOrientation.STATIC
    darkMenu: boolean = false
    profileMode: string = 'inline'
    rotateMenuButton: boolean
    topbarMenuActive: boolean
    overlayMenuActive: boolean
    staticMenuDesktopInactive: boolean
    staticMenuMobileActive: boolean
    layoutContainer: HTMLDivElement
    layoutMenuScroller: HTMLDivElement
    menuClick: boolean
    topbarItemClick: boolean
    activeTopbarItem: any
    documentClickListener: Function
    resetMenu: boolean
    private usuario: any
    linkIframe: any = `${environment.apiEndpoint}/api/Autenticar/`
    linkIFrameSanitized: any
    displayMessageInWindow: boolean = false
    displayDialogInMainWindow: boolean = false
    displayDialogInIframe: boolean = false
    bloquearTelaPrincipal: boolean = true
    msgs: Message[] = []
    funcionalidadesPublicas: string[] = ['#/consultas/consulta-cnaipj', '#/documentos/certidao-cnaipj', '#/documentos/validar-documentos'];
    sticky: boolean = true
    @ViewChild(AppTopBar) appTopBar: AppTopBar
    private subscription: Subscription
    @ViewChild('layoutContainer') layourContainerViewChild: ElementRef
    @ViewChild('layoutMenuScroller') layoutMenuScrollerViewChild: ElementRef

    constructor(public renderer: Renderer,
        private breadcrumbService: BreadcrumbService,
        private usuarioSessao: bObservableUsuario,
        private jwtHelper: JwtHelper,
        private sanitizer: DomSanitizer,
        private autenticacaoService: AutenticacaoService) {
        this.breadcrumbService.addCallbackForRouteRegex('(usuario)$', (id: string) => {
            return id.replace(/\w\S*/g, function (id) { return id.charAt(0).toUpperCase() + id.substr(1).toLowerCase(); })
        });

        this.subscription = this.usuarioSessao.getValue.subscribe(
            data => {
                this.usuario = data.obj;
                if (this.usuario != null) {
                    if (!window.frameElement) {
                        localStorage.removeItem("cpfUsuarioLogadoMainWindow");
                        localStorage.setItem("cpfUsuarioLogadoMainWindow", this.usuario.cpf)
                    }
                    else {
                        localStorage.removeItem("cpfUsuarioLogadoIframe");
                        localStorage.setItem("cpfUsuarioLogadoIframe", this.usuario.cpf)
                    }
                }
            }
        );
        this.breadcrumbService.addFriendlyNameForRouteRegex('([a-z]*)\/cadastrar', 'Cadastrar');
        this.breadcrumbService.addFriendlyNameForRouteRegex('([a-z]*)\/enviar-cadastro\/([0-9]*)', 'Enviar');
        this.breadcrumbService.addFriendlyNameForRouteRegex('([a-z]*)\/analisar\/([0-9]*)', 'Analisar');
        this.breadcrumbService.addFriendlyNameForRouteRegex('([a-z]*)\/editar\/([0-9]*)', 'Editar');
        this.breadcrumbService.addFriendlyNameForRouteRegex('([a-z]*)\/visualizar\/([0-9]*)', 'Visualizar');
        this.breadcrumbService.addFriendlyNameForRouteRegex('([a-z]*)\/encaminhar\/([0-9]*)', 'Encaminhar');
        this.breadcrumbService.hideRouteRegex('([a-z]*)\/(editar|visualizar|encaminhar|analisar|enviar-cadastro)$');

        EventEmitterService.get(EVENT_MSGS_UPDATE).subscribe(x => {
            this.msgs = x;
        });
    }

    verificarToken() {
        let rota = window.location.hash;
        if ((this.funcionalidadesPublicas.filter(f => rota.includes(f)).length > 0)) {
            this.bloquearTelaPrincipal = false;
        }
        if (localStorage.getItem("token")) {
            if (this.jwtHelper.isTokenExpired(localStorage.getItem("token"))) {
                this.bloquearTelaPrincipal = true;
            } else {
                if (window.frameElement) {
                    this.displayDialogInIframe = true;
                }
                this.bloquearTelaPrincipal = false;
            }
        }
    }
    ngOnInit() {
        this.autenticacaoService.obterPermissoesUsuario()
        this.verificarToken();
    }

    returnLinkIframeSanitized(): SafeValue {
        this.verificarToken();
        if (this.linkIFrameSanitized == null)
            this.linkIFrameSanitized = this.sanitizer.bypassSecurityTrustResourceUrl(this.linkIframe);
        return this.linkIFrameSanitized;
    }

    showDialog(event: any) {
        this.displayDialogInMainWindow = event;
    }

    verificarTokenEUsuarioLogado() {
        if ((localStorage.getItem("token") &&
            !this.jwtHelper.isTokenExpired(localStorage.getItem("token"))) &&
            localStorage.getItem("cpfUsuarioLogadoMainWindow") == localStorage.getItem("cpfUsuarioLogadoIframe"))
            this.appTopBar.reiniciarContagemToken();
        else
            window.location.href = `${environment.apiEndpoint}/api/Autenticar/`;
    }

    ngAfterViewInit() {
        if (this.bloquearTelaPrincipal == false) {
            this.layoutContainer = <HTMLDivElement>this.layourContainerViewChild.nativeElement;
            this.layoutMenuScroller = <HTMLDivElement>this.layoutMenuScrollerViewChild.nativeElement;
        }

        //hides the horizontal submenus or top menu if outside is clicked
        this.documentClickListener = this.renderer.listenGlobal('body', 'click', (event) => {
            if (!this.topbarItemClick) {
                this.activeTopbarItem = null;
                this.topbarMenuActive = false;
            }

            if (!this.menuClick && this.isHorizontal()) {
                this.resetMenu = true;
            }

            this.topbarItemClick = false;
            this.menuClick = false;
        });

        setTimeout(() => {
            jQuery(this.layoutMenuScroller).nanoScroller({ flash: true });
        }, 10);
    }

    onMenuButtonClick(event) {
        this.rotateMenuButton = !this.rotateMenuButton;
        this.topbarMenuActive = false;

        if (this.layoutMode === MenuOrientation.OVERLAY) {
            this.overlayMenuActive = !this.overlayMenuActive;
        }
        else {
            if (this.isDesktop())
                this.staticMenuDesktopInactive = !this.staticMenuDesktopInactive;
            else
                this.staticMenuMobileActive = !this.staticMenuMobileActive;
        }

        event.preventDefault();
    }

    onMenuClick($event) {
        this.menuClick = true;
        this.resetMenu = false;

        if (!this.isHorizontal()) {
            setTimeout(() => {
                jQuery(this.layoutMenuScroller).nanoScroller();
            }, 500);
        }
    }

    onTopbarMenuButtonClick(event) {
        this.topbarItemClick = true;
        this.topbarMenuActive = !this.topbarMenuActive;

        if (this.overlayMenuActive || this.staticMenuMobileActive) {
            this.rotateMenuButton = false;
            this.overlayMenuActive = false;
            this.staticMenuMobileActive = false;
        }

        event.preventDefault();
    }

    onTopbarItemClick(event, item) {
        this.topbarItemClick = true;

        if (this.activeTopbarItem === item)
            this.activeTopbarItem = null;
        else
            this.activeTopbarItem = item;

        event.preventDefault();
    }

    isTablet() {
        let width = window.innerWidth;
        return width <= 1024 && width > 640;
    }

    isDesktop() {
        return window.innerWidth > 1024;
    }

    isMobile() {
        return window.innerWidth <= 640;
    }

    isOverlay() {
        return this.layoutMode === MenuOrientation.OVERLAY;
    }

    isHorizontal() {
        return this.layoutMode === MenuOrientation.HORIZONTAL;
    }

    changeToStaticMenu() {
        this.layoutMode = MenuOrientation.STATIC;
    }

    changeToOverlayMenu() {
        this.layoutMode = MenuOrientation.OVERLAY;
    }

    changeToHorizontalMenu() {
        this.layoutMode = MenuOrientation.HORIZONTAL;
    }

    ngOnDestroy() {
        this.subscription.unsubscribe();
        if (this.documentClickListener) {
            this.documentClickListener();
        }

        jQuery(this.layoutMenuScroller).nanoScroller({ flash: true });
    }

}


// WEBPACK FOOTER //
// ./src/app/app.component.ts